import React, { useEffect } from "react";
import moment from "moment";
import DateMomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Theme, ThemeProvider, makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as Glob from "src/Globale";
import theme from "../theme";
import { _Footer, _Header } from "../layout";
import { _AlertDialog } from "../components";

const useStyles = makeStyles(({ palette }: Theme) => ({
    "@global": {
        ".hidden": {
            display: "none"
        },
        ".error": {
            background: palette.error.main,
            color: palette.error.contrastText
        },
        ".info": {
            background: palette.info.light,
            color: palette.info.contrastText
        },
        ".success": {
            backgroundColor: palette.success.light,
            color: palette.success.contrastText
        },
        ".warning": {
            backgroundColor: palette.warning.light,
            color: palette.warning.contrastText
        },
        ".numberInput": {
            textAlign: "right"
        }
    }
}));

export const _PageWrapper: React.FC<Glob.IGlobaleProps> = props => {
    useStyles();

    useEffect(() => {
        const session = Glob.GetSessione();

        document.title = `InAR - ${location.pathname} - Client: ${Glob.Version} Server: ${session.Versione} - ${session.ConfigurazioneCompilazione}`;
        document.querySelector('link[href*="assets/metronic/vendors.min.css"]')?.remove();
        document.querySelector('link[href*="assets/metronic/main-styles.css"]')?.remove();
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider libInstance={moment} utils={DateMomentUtils} locale={props.Globale[Glob.TTipiGlobale.Locale].Lingua}>
                <CssBaseline />
                <_Header {...props} />
                {props.children}
                <_AlertDialog />
                <_Footer {...props} />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/PageWrapper.tsx